import month from "../../constant/month.json";
import classes from './Headlines.module.css'

import bankIcon from '../../assets/images/bank_icon.png'

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1;

function Headlines() {
    return (
        <>
            <div className={classes.headerText}>
                <h2>The Top APY <span style={{ color: "#2da83e!important" }}>Savings Accounts</span> from Our Partners for {month[currentMonth]} {currentYear}</h2>
            </div>
            <div className={classes.subheaderText}>
                <img loading="lazy" src={bankIcon} alt="bank icon" />
                <h4>Compare the Top High Yield Savings Accounts</h4>
            </div>
            <div className={classes.subheaderText}>
                <img loading="lazy" src={bankIcon} alt="bank icon" />
                <h4>Open a New Account in Minutes</h4>
            </div>
        </>
    )
}

export default Headlines